import React from 'react';

const Planes = () => {
  return (
    <section className="py-24 bg-black overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        
        {/* ENCABEZADO Y REFLEXIÓN */}
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter text-white mb-6">
            Planes de Previsión
          </h2>
          {/* Reflexión con letras delgadas y sutiles */}
          <p className="max-w-3xl mx-auto text-zinc-500 font-extralight text-sm md:text-base leading-relaxed tracking-wide italic">
            "Toma el control para prepararse para lo inevitable y responsabilízate de tu familia para no dejar problemas en esos duros momentos. Tomemos conciencia para tener serenidad y seguridad en esos tiempo dificiles."
          </p>
          <div className="h-px w-12 bg-yellow-400/50 mx-auto mt-8"></div>
        </div>

        {/* CONTENEDOR DE PLANES CON ANIMACIÓN DE DESVANECIMIENTO */}
        <div className="grid lg:grid-cols-3 gap-8 animate-in fade-in slide-in-from-bottom-10 duration-1000 ease-out fill-mode-forwards opacity-0 translate-y-10" 
             style={{ animation: 'fadeInUp 1.5s forwards' }}>
          
          {/* Plan Elite "C" */}
          <div className="bg-zinc-900/40 border border-zinc-800 p-8 rounded-[2rem] hover:border-zinc-700 transition-all duration-500">
            <span className="text-red-500 text-[10px] font-bold uppercase tracking-widest">Programa PABS</span>
            <h3 className="text-3xl font-black text-white mt-2 mb-4 italic">Elite "C"</h3>
            <div className="text-4xl font-black text-white mb-6">$23,900</div>
            <ul className="space-y-3 text-zinc-400 text-sm mb-8 font-light">
              <li>• Ataúd Metálico</li>
              <li>• Urna-Cremación Incluida</li>
              <li>• 100% Transferible</li>
            </ul>
            <div className="pt-6 border-t border-zinc-800">
              <p className="text-[10px] text-zinc-500 uppercase font-bold mb-3">Pagos desde:</p>
              <div className="flex gap-2">
                {['$125', '$250', '$500'].map(pago => (
                  <span key={pago} className="bg-zinc-800 px-3 py-1 rounded text-[11px] font-bold">{pago}</span>
                ))}
              </div>
            </div>
          </div>

          {/* Plan Regazo (Destacado) */}
          <div className="bg-zinc-900/60 border border-red-900/30 p-8 rounded-[2rem] shadow-2xl shadow-red-900/5 transform hover:scale-[1.02] transition-all duration-500">
            <span className="text-red-500 text-[10px] font-bold uppercase tracking-widest">Programa PABS</span>
            <h3 className="text-3xl font-black text-white mt-2 mb-4 italic uppercase">Regazo</h3>
            <div className="text-4xl font-black text-white mb-6">$26,900</div>
            <ul className="space-y-3 text-zinc-300 text-sm mb-8 font-light">
              <li>• Ataúd Madera Fina</li>
              <li>• Urna-Cremación Incluida</li>
              <li>• 100% Transferible</li>
            </ul>
            <div className="pt-6 border-t border-zinc-800">
              <p className="text-[10px] text-zinc-500 uppercase font-bold mb-3">Pagos desde:</p>
              <div className="flex gap-2">
                {['$145', '$290', '$580'].map(pago => (
                  <span key={pago} className="bg-zinc-800 px-3 py-1 rounded text-[11px] font-bold">{pago}</span>
                ))}
              </div>
            </div>
          </div>

          {/* Plan Italia */}
          <div className="bg-zinc-900/40 border border-zinc-800 p-8 rounded-[2rem] hover:border-zinc-700 transition-all duration-500">
            <span className="text-red-500 text-[10px] font-bold uppercase tracking-widest">Programa PABS</span>
            <h3 className="text-3xl font-black text-white mt-2 mb-4 italic uppercase">Italia</h3>
            <div className="text-4xl font-black text-white mb-6">$32,000</div>
            <ul className="space-y-3 text-zinc-400 text-sm mb-8 font-light">
              <li>• Ataúd Madera Italia</li>
              <li>• Urna-Cremación Incluida</li>
              <li>• 100% Transferible</li>
            </ul>
            <div className="pt-6 border-t border-zinc-800">
              <p className="text-[10px] text-zinc-500 uppercase font-bold mb-3">Pagos desde:</p>
              <div className="flex gap-2">
                {['$175', '$350', '$700'].map(pago => (
                  <span key={pago} className="bg-zinc-800 px-3 py-1 rounded text-[11px] font-bold">{pago}</span>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Estilo CSS para la animación (Puedes ponerlo en tu index.css) */}
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(40px) scale(0.95);
            filter: blur(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
            filter: blur(0);
          }
        }
      `}</style>
    </section>
  );
};

export default Planes;